import unexpectedErrorImage from "assets/images/error/unexpected_error.svg"
import NoResultsImage from "assets/images/error/search_page_error.svg"

type ErrorMessage = {
	name: string
	img?: string
	message: string
	hasRetry: boolean
}

const TITLE_ERROR = "phronesis.error.metrics.title"
const METRIC_MESSAGE = "phronesis.error.metrics.message"

export enum ErrorResponseCodes {
	Metric = "PH-0001",
	Timeout = "PH-0003",
	Generic = "Generic",
	InvalidDates = "PH-0007",
}

export enum HttpCodes {
	RequestTimeout = "408",
	InternalServerError = "500",
	GatewayTimeout = "504",
	BadRequest = "400",
	NotFound = "404",
}

export const textRetryButton = {
	id: "phronesis.error.button.message",
}

export const NoDataMessage: ErrorMessage = {
	name: "phronesis.error.nodata.title",
	message: "phronesis.error.nodata.message",
	img: NoResultsImage,
	hasRetry: false,
}

export const GENERIC_ERROR = {
	status: HttpCodes.InternalServerError,
	errCode: ErrorResponseCodes.Generic,
}

export const ErrorMessages: Record<string, ErrorMessage> = {
	[ErrorResponseCodes.Timeout]: {
		name: TITLE_ERROR,
		message: "phronesis.error.timeout.message",
		hasRetry: true,
		img: unexpectedErrorImage,
	},
	[ErrorResponseCodes.InvalidDates]: {
		name: TITLE_ERROR,
		message: "phronesis.error.timeout.message",
		hasRetry: false,
		img: unexpectedErrorImage,
	},
	[ErrorResponseCodes.Metric]: {
		name: TITLE_ERROR,
		message: METRIC_MESSAGE,
		hasRetry: false,
	},
	[ErrorResponseCodes.Generic]: {
		name: TITLE_ERROR,
		message: METRIC_MESSAGE,
		hasRetry: true,
		img: unexpectedErrorImage,
	},
	[HttpCodes.RequestTimeout]: {
		name: TITLE_ERROR,
		message: "phronesis.error.timeout.message",
		hasRetry: true,
		img: unexpectedErrorImage,
	},
	[HttpCodes.InternalServerError]: {
		name: TITLE_ERROR,
		message: METRIC_MESSAGE,
		hasRetry: true,
		img: unexpectedErrorImage,
	},
	[HttpCodes.GatewayTimeout]: {
		name: TITLE_ERROR,
		message: METRIC_MESSAGE,
		hasRetry: true,
		img: unexpectedErrorImage,
	},
	[HttpCodes.BadRequest]: {
		name: TITLE_ERROR,
		message: METRIC_MESSAGE,
		hasRetry: false,
		img: unexpectedErrorImage,
	},
	[HttpCodes.NotFound]: {
		name: TITLE_ERROR,
		message: METRIC_MESSAGE,
		hasRetry: false,
		img: unexpectedErrorImage,
	},
}
